import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import WhyChoose from "./components/WhyChoose";
import HowItWorks from "./components/HowItWorks";
import Services from "./components/Services";
import ExperienceConcept from "./components/ExperienceConcept";
import Gallery from "./components/Gallery";
import Menu from "./components/Menu";
import CTA from "./components/CTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <WhyChoose />
      <HowItWorks />
      <Services />
      <ExperienceConcept />
      <Gallery />
      <Menu />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
